import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-343f37fb"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "dash-navigation",
  class: "dash-navigation"
}
const _hoisted_2 = { class: "logo-dash-main" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_5 = { class: "partner-text" }
const _hoisted_6 = { class: "partner-text__partner" }
const _hoisted_7 = { class: "partner-text__id" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_9 = { class: "nav-headers" }
const _hoisted_10 = ["onClick", "onKeypress"]
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = {
  id: "dash-navigation-mobile",
  class: "dash-navigation-mobile"
}
const _hoisted_13 = { class: "dash-items-mobile" }
const _hoisted_14 = ["src"]
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  key: 0,
  id: "dash-navigation-mobile-wrap",
  class: "dash-navigation-mobile-wrap"
}
const _hoisted_17 = { class: "dash-items-mobile-wrap" }
const _hoisted_18 = ["src"]
const _hoisted_19 = ["src"]
const _hoisted_20 = ["onClick", "onKeypress"]
const _hoisted_21 = ["src"]
const _hoisted_22 = ["onClick", "onKeypress"]
const _hoisted_23 = { class: "logout-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: require('@/assets/Logo_secondary_for_yellow_bg.svg'),
              alt: "YellowCard Logo"
            }, null, 8, _hoisted_3)
          ]),
          _: 1
        })
      ]),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.partner?.name), 1),
        _createElementVNode("div", _hoisted_7, "ID: " + _toDisplayString(_ctx.user?.partnerId), 1)
      ]),
      _hoisted_8,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.navigations), (linkParent, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          _createElementVNode("div", _hoisted_9, _toDisplayString(linkParent), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navigations[linkParent], (nav, navIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              key: navIndex,
              class: _normalizeClass(["nav-item", _ctx.isRoutePath(_ctx.$route.path, nav.link) ? 'active' : '']),
              onClick: ($event: any) => (_ctx.go(nav.link)),
              onKeypress: ($event: any) => (_ctx.go(nav.link))
            }, [
              _createElementVNode("img", {
                src: require('@/assets/navigation/' + nav.icon + '.svg'),
                alt: nav.label
              }, null, 8, _hoisted_11),
              _createTextVNode("  " + _toDisplayString(nav.label), 1)
            ], 42, _hoisted_10))
          }), 128))
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", null, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: require('@/assets/Logo_secondary_for_yellow_bg.svg'),
                alt: "YellowCard Logo"
              }, null, 8, _hoisted_14)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.toggleMobileMenu()), ["prevent"])),
          onKeypress: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleMobileMenu()))
        }, [
          _createElementVNode("img", {
            src: require('@/assets/navigation/hamburger.svg'),
            alt: "hamburger"
          }, null, 8, _hoisted_15)
        ], 32)
      ])
    ]),
    (_ctx.showDropDown)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", null, [
              _createVNode(_component_router_link, {
                to: "/",
                class: "logo"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: require('@/assets/device_secondary_for_yellow_bg.svg'),
                    alt: "YellowCard Logo",
                    class: "dash-navigation-mobile-wrap_device_secondary_for_yellow_bg"
                  }, null, 8, _hoisted_18)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", {
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.toggleMobileMenu()), ["prevent"])),
              onKeypress: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleMobileMenu()))
            }, [
              _createElementVNode("img", {
                src: require('@/assets/navigation/menu_close.svg'),
                alt: "menu close",
                class: "menu_close"
              }, null, 8, _hoisted_19)
            ], 32)
          ]),
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.navigations), (linkParent, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createElementVNode("div", {
                  class: "items-mobile-wrap-text",
                  onClick: _withModifiers(($event: any) => (_ctx.toggleMobileMenuAccordion(linkParent)), ["prevent"]),
                  onKeypress: ($event: any) => (_ctx.toggleMobileMenuAccordion(linkParent))
                }, [
                  _createElementVNode("div", null, _toDisplayString(linkParent), 1),
                  _createElementVNode("div", null, [
                    _createElementVNode("img", {
                      src: require('@/assets/navigation/chevron_down.svg'),
                      alt: "chevron down",
                      class: "chevron_down"
                    }, null, 8, _hoisted_21)
                  ])
                ], 40, _hoisted_20),
                _createElementVNode("div", {
                  class: _normalizeClass({
            'display-hidden': _ctx.showDropDownMenu !== linkParent,
          })
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navigations[linkParent], (nav, navIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: navIndex,
                      class: _normalizeClass(["nav-item", {
              active: _ctx.isRoutePath(_ctx.$route.path, nav.link),
            }]),
                      onClick: ($event: any) => (_ctx.go(nav.link)),
                      onKeypress: ($event: any) => (_ctx.go(nav.link))
                    }, _toDisplayString(nav.label), 43, _hoisted_22))
                  }), 128))
                ], 2)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_Button, {
              text: "Log out",
              variant: "outline",
              onButtonClicked: _ctx.logOut
            }, null, 8, ["onButtonClicked"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}